import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "../../../constants/apiPath";
import axios from "axios";

const initialState = {
  isLoading: false,
  colors: {},
};
const THUNK_METHODS = {
  COLORS_GET: "user/colors",
};



export const getColors = createAsyncThunk(
  THUNK_METHODS.COLORS_GET,
  async (args, { rejectWithValue }) => {
    try {
      const {data} = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}${API.COLORS.GET}`,
        withCredentials: true,
      });
      return data;
    } catch (error) {
      console.error(error.message);
      return rejectWithValue("SignUp failed");
    }
  }
);

export const colorSlice = createSlice({
  name: "color",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getColors.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getColors.fulfilled, (state, action) => {
      state.colors = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getColors.rejected, (state) => {
      state.isLoading = false;
    });
  },
});
export const { } = colorSlice.actions;
